export const depositOrderFilterData = state => state.depositOrderFilterData
